module.exports = __webpack_public_path__ + "img/icon_like_active.0d934ce1.svg";